import PropTypes from "prop-types";
import { STATUS_CONFIG } from "../constants/statuses";

export default function StatusBadge({ status }) {
	const config = STATUS_CONFIG[status] || STATUS_CONFIG.PENDING;
	return (
		<span
			className={`px-2 py-0.5 rounded-full text-xs font-medium border ${config.color}`}
		>
			{config.label}
		</span>
	);
}

StatusBadge.propTypes = {
	status: PropTypes.string.isRequired,
};
